import { ISendEmailNovosNegociosUseCase } from "../../../presentation/useCases/read/send_email_novos_negocios_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * SendEmailNovosNegociosUseCase
 */

export class SendEmailNovosNegociosUseCase implements ISendEmailNovosNegociosUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(
    idNovosNegocios: number,
    subject: string,
    sendTo: string,
    body: string,
    attachment: string,
  ): Promise<void> {
    const emails = sendTo.split(';');

    emails.forEach(e => e.trim());

    await this.repository
      .sendEmailNovosNegocios(
        idNovosNegocios,
        subject,
        emails,
        body,
        attachment,
      );
  }
}
